module.exports = __webpack_public_path__ + "img/458-3150c7.png";